import React from "react"
import * as styles from "./index.module.scss"
import Container from "@/components/container"
import Markdown from "@/components/markdown"
import cls from "classnames"

const PrivacyPolicyContent: React.FC<PrivacyPolicyBody> = ({
  body,
  archive,
}) => {
  return (
    <Container>
      <div
        className={cls(
          "common-center-container",
          styles.content,
          archive ? styles.archive : ""
        )}
      >
        <Markdown body={body} needAnchor />
      </div>
    </Container>
  )
}

export default PrivacyPolicyContent
